// src/features/executive/insight/hooks/use-retention.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import InsightApi from 'api/executive/insight.api'
import type {
  GetInsightRetentionParams,
  InsightRetentionResponse,
} from 'api/executive/executive.types'

export function useRetention() {
  return useExecutiveQuery<GetInsightRetentionParams, InsightRetentionResponse>(
    'insight.retention',
    InsightApi.getRetention,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        patientType: f.patientType ?? undefined,
        nationality: f.nationality ?? undefined,
        sourceChannel: f.sourceChannel ?? undefined,
        promotionId: f.promotionId ?? undefined,
      }
    }
  )
}
